module.exports = __webpack_public_path__ + "img/absorbente18.3835e832.jpg";